{
    "Accessibility menu": "မည်သူမဆို အသုံးပြုနိုင်သော မီနူး",
    "Close": "ပိတ်ပါ",
    "Text and Reading": "စာသားနှင့် ဖတ်ရှုခြင်း",
    "Navigation and Interaction": "လမ်းညွှန်မှုနှင့် အပြန်အလှန်ဆက်သွယ်မှု",
    "Text Align": "စာသားနေရာချ",
    "Align Left": "ဘယ်ဘက်သို့ ညှိပါ",
    "Align Center": "အလယ်တွင် ချိန်ညှိ",
    "Align Right": "ညာဘက်သို့ ချိန်ညှိ",
    "Adjust Font Size": "ဖောင့်အရွယ်အစားကို ချိန်ညှိပါ",
    "Highlight Title": "ခေါင်းစဉ်ကို အထူးပြုပါ",
    "Highlight Links": "လင့်များကို အထူးပြုပါ",
    "Readable Font": "ဖတ်ရန်လွယ်ကူသော ဖောင့်",
    "Color and Contrast": "အရောင်နှင့် ကွာခြားမှု",
    "Dark Contrast": "မှောင်မိုက်သော ကွာခြားမှု",
    "Light Contrast": "အလင်းရောင် ကွာခြားမှု",
    "High Contrast": "မြင့်မားသော ကွာခြားမှု",
    "High Saturation": "မြင့်မားသော အရောင်စွဲမှု",
    "Low Saturation": "နိမ့်သော အရောင်စွဲမှု",
    "Monochrome": "တစ်ရောင်တည်း",
    "Tools": "ကိရိယာများ",
    "Reading Guide": "ဖတ်ရှုရန် လမ်းညွှန်",
    "Big Cursor": "ကြီးမားသော ကာဆာ",
    "Increase Font Size": "ဖောင့်အရွယ်အစားကို တိုးချဲ့ပါ",
    "Decrease Font Size": "ဖောင့်အရွယ်အစားကို လျှော့ချပါ",
    "Letter Spacing": "အက္ခရာအကြား အကွာအဝေး",
    "Line Height": "စာကြောင်းအမြင့်",
    "Font Weight": "ဖောင့်အလေးချိန်",
    "Dyslexia Font": "Dyslexia ဖောင့်",
    "Language": "ဘာသာစကား",
    "Accessibility widget": "မည်သူမဆို အသုံးပြုနိုင်သော မီနူးကို ဖွင့်ပါ",
    "Accessibility Profiles": "မည်သူမဆို အသုံးပြုနိုင်သော ပရိုဖိုင်များ",
    "Cognitive Disability": "သိမြင်မှုဆိုင်ရာ မသန်စွမ်းမှု",
    "Seizure Safe": "အတက်ရောဂါအတွက် ဘေးကင်းလုံခြုံသော",
    "Accessibility statement": "မည်သူမဆို အသုံးပြုနိုင်သော ကြေညာချက်",
    "ADHD": "ADHD",
    "Low Vision": "အမြင်အာရုံနည်း",
    "Pause Animations": "အန်နီမေးရှင်းများကို ရပ်ပါ",
    "Animation paused": "သက်ဝင်လှုပ်ရှားမှု ခေတ္တရပ်ထားသည်",
    "Reset all settings": "ဆက်တင်များကို ပြန်လည်သတ်မှတ်ပါ",
    "Shortcut:": "ဖြတ်လမ်း:",
    "Epilepsy Safe Mode": "ဝက်ရူးပြန်ရောဂါ လုံခြုံမုဒ်",
    "Mute sounds": "အသံပိတ်ရန်",
    "Page read": "စာမျက်နှာ ဖတ်ပြခြင်း",
    "Page read controls": "စာမျက်နှာ ဖတ်ပြခြင်း ထိန်းချုပ်မှုများ",
    "Pause": "ခဏရပ်ရန်",
    "Resume": "ပြန်စရန်",
    "Stop": "ရပ်ရန်",
    "Settings": "ဆက်တင်များ",
    "Speed": "အမြန်နှုန်း",
    "Voice": "အသံ",
    "Close accessibility menu": "အသုံးပြုနိုင်စွမ်း မီနူးကို ပိတ်ရန်",
    "Back to accessibility menu": "အသုံးပြုနိုင်စွမ်း မီနူးသို့ ပြန်သွားရန်",
    "Search languages": "ဘာသာစကားများ ရှာဖွေရန်",
    "Selected language": "ရွေးချယ်ထားသော ဘာသာစကား",
    "View accessibility statement (opens in new window)": "အသုံးပြုနိုင်စွမ်း ကြေညာချက်ကို ကြည့်ရန် (ဝင်းဒိုးအသစ်တွင် ဖွင့်သည်)",
    "Visit CookieYes website (opens in new window)": "CookieYes ဝဘ်ဆိုက်သို့ သွားရောက်ရန် (ဝင်းဒိုးအသစ်တွင် ဖွင့်သည်)",
    "Reset all accessibility settings to default": "အသုံးပြုနိုင်စွမ်း ဆက်တင်အားလုံးကို မူလအတိုင်း ပြန်လည်သတ်မှတ်ရန်"
}
